import { Box, BoxProps, HStack } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { getSkinDisplayRarity } from '../utils/getSkinDisplayRarity'
import { getRarityColorMap, rarityType } from '../constants/skinPropertes'
import SkinCardWrapper from './SkinCardWrapper'
import SkinCardImage from './SkinCardImageV2'
import { getSteamImageUrl } from '../utils/getSteamImage'
import { RushSkin } from '../types/rush'
import { Skin, SkinWithFetchStatus } from '../types'
import { useLanguagePath } from '../hooks/useI18nRoute'
import RushSkinCardWrapper from './RushSkinCardWrapper'
import { colors } from '../theme/cssVariables'
import { setIsOpenRushSkinsModal } from '../store/rushbSlice'
import { SkinTooltip } from './SkinTooltip'

const RushSkinCard = (
  props: {
    skin: RushSkin
    children?: React.ReactNode
  } & BoxProps,
) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const getPath = useLanguagePath()
  const { skin, children, ...rest } = props
  const displayRarity = getSkinDisplayRarity(skin.treasure?.rarity, skin.treasure?.name)
  const handleCheckTrade = (skin: RushSkin) => {
    navigate(getPath(`provably-fair/${skin.instanceId}`))
    dispatch(setIsOpenRushSkinsModal(false))
  }
  return (
    <Box position={'relative'}>
      <RushSkinCardWrapper
        rarity={displayRarity as unknown as rarityType}
        width={['272px']}
        height={'auto'}
        role="group"
        position="relative"
        {...rest}
      >
        <SkinCardImage
          maxW={'55%'}
          top={[5, 7]}
          imageSrc={skin.treasure?.imageURL}
          fallback={getSteamImageUrl(skin.treasure?.marketHash)}
          rarity={displayRarity as unknown as rarityType}
          treasureStyle={{
            paddingBottom: '8px',
          }}
          mb={2}
        />

        {children}
      </RushSkinCardWrapper>

      <HStack spacing="10px" position={'absolute'} right={['8px', 4]} top={['8px', '14px']}>
        {skin.referenceType === 'BOX_OPEN' && (
          <SkinTooltip
            skin={skin as unknown as SkinWithFetchStatus}
            onCheck={() => handleCheckTrade(skin)}
            shieldCheckIconColor={colors.colorA4}
          />
        )}
      </HStack>
    </Box>
  )
}
export default RushSkinCard
